<template>
  <div class="calendario-container p-2 sm:p-4 glass-app w-full h-full" :class="{ 'theme-light': theme === 'light' }">
    <!-- Técnico + Pesquisa na mesma linha -->
    <div class="flex flex-wrap gap-2 items-center mb-3 relative" ref="tecnicoDropdownRef">
      <div class="flex items-center gap-1 flex-1 min-w-[160px]">
        <label class="sm:min-w-[4rem]">Técnico:</label>
        <div class="relative flex-1">
          <input type="text" v-model="tecnico_search" @focus="tecnicoDropdownOpen = true" @input="tecnicoDropdownOpen = true"
            :placeholder="select_tecnico ? nomeTecnico(tecnicos.find(t => t.id === select_tecnico)) || 'Selecione Técnico' : 'Selecione Técnico'"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                   focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5
                   dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
                   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
          <button v-if="select_tecnico" @click="clearTecnico" type="button"
            class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white text-sm">
            <i class="fa-solid fa-xmark"></i>
          </button>
          <ul v-if="tecnicoDropdownOpen && filteredTecnicos.length > 0"
            class="absolute z-50 mt-1 w-full max-h-60 overflow-auto rounded-lg border border-gray-600 bg-gray-700 text-white text-sm shadow-lg">
            <li v-for="tecnico in filteredTecnicos" :key="tecnico.id"
              @mousedown.prevent="selectTecnico(tecnico)"
              class="px-3 py-2 cursor-pointer hover:bg-gray-600"
              :class="{ 'bg-blue-600 hover:bg-blue-500': tecnico.id === select_tecnico }">
              {{ nomeTecnico(tecnico) }}
            </li>
          </ul>
          <div v-if="tecnicoDropdownOpen && filteredTecnicos.length === 0 && tecnico_search"
            class="absolute z-50 mt-1 w-full rounded-lg border border-gray-600 bg-gray-700 text-gray-400 text-sm shadow-lg px-3 py-2">
            Nenhum técnico encontrado
          </div>
        </div>
      </div>
      <div class="flex items-center gap-1 flex-1 min-w-0">
        <label class="sm:min-w-[4rem]">Pesquisa:</label>
        <input type="text" v-model="search_text" @keyup.enter="pesquisar_calendario()" placeholder="Pesquisar..."
          class="bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg flex-1 min-w-0 p-2.5" />
      </div>
      <button type="button" @click="abrirRotaModal" :disabled="!select_tecnico"
        :title="select_tecnico ? 'Ver rota das visitas no período visível' : 'Selecione um técnico primeiro'"
        class="ver-rota-btn flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm text-white bg-purple-600 hover:bg-purple-500 disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap">
        <i class="fas fa-route"></i> Ver Rota
      </button>
    </div>

    <!-- Barra de ações em massa (visível quando um técnico está selecionado) -->
    <Transition name="slide-up">
      <div v-if="select_tecnico" class="flex flex-wrap items-center justify-between gap-2 px-3 py-2 mb-3 rounded-lg" style="background:#1e3a5f; border:1px solid #3b82f6;">
        <div class="flex items-center gap-3">
          <template v-if="hasSelectedEvents">
            <span class="text-sm font-bold text-blue-200">{{ selectedCount }} serviço(s) selecionado(s)</span>
            <button @click="clearSelection" type="button" class="text-xs text-gray-400 hover:text-white flex items-center gap-1">
              <i class="fa-solid fa-xmark"></i> Limpar
            </button>
          </template>
          <button @click="selectAll" type="button"
            class="flex items-center gap-1 px-3 py-1.5 rounded text-xs text-white whitespace-nowrap"
            :class="allEligibleSelected ? 'bg-gray-600 hover:bg-gray-500' : 'bg-teal-600 hover:bg-teal-500'">
            <i :class="allEligibleSelected ? 'fa-solid fa-square-minus' : 'fa-solid fa-square-check'"></i>
            {{ allEligibleSelected ? 'Desselecionar Todos' : 'Selecionar Todos' }}
          </button>
        </div>
        <div v-if="hasSelectedEvents" class="flex flex-wrap gap-2">
          <button @click="bulkTransfer" type="button" class="flex items-center gap-1 px-3 py-1.5 rounded text-xs text-white" style="background:#2563eb;">
            <i class="fa-solid fa-right-left"></i> Transferir
          </button>
          <button @click="bulkChangeDate" type="button" class="flex items-center gap-1 px-3 py-1.5 rounded text-xs text-white" style="background:#d97706;">
            <i class="fa-solid fa-calendar-days"></i> Mudar Data
          </button>
          <button @click="bulkDesagendar" type="button" class="flex items-center gap-1 px-3 py-1.5 rounded text-xs text-white" style="background:#15803d;">
            <i class="fa-solid fa-calendar-minus"></i> Desagendar
          </button>
          <button @click="bulkDesalocar" type="button" class="flex items-center gap-1 px-3 py-1.5 rounded text-xs text-white" style="background:#4338ca;">
            <i class="fa-solid fa-user-minus"></i> Desalocar
          </button>
        </div>
      </div>
    </Transition>

    <FullCalendar ref="calendarRef" :options="calendarOptions" />

    <div v-if="!props.monthOnly" class="grid grid-cols-2 sm:grid-cols-3 grid-rows-1 gap-3 mt-5">
      <div>
        <p>Técnico:</p>
        <p>Objectivo:</p>
        <p>Valores Serviços:</p>
      </div>
      <div class="sm:col-start-3">
        <p>{{ nomeTecnicoSelecionado }}</p>
        <p>{{ objectivo + " €" ?? "—" }}</p>
        <p>{{ valores + " €" ?? "—" }}</p>
        <hr>
        <button v-if="mostrar_agendar" @click="agendar_servicos()" type="button" class="btn mt-4"> Agendar </button>
      </div>
    </div>

    <div class="w-full">
      <popUp title="Informação do Planeamento" v-if="showModal" :edit_mode="popUpEdit_mode" :model="modalModel"
        :modelData="modalData" :setData="modalSetData" @save_form="gravarDadosPlaneamento" @close="fecharModal" />
    </div>

    <div class="w-full">
      <createPopUp
        v-if="showCreatePopUp"
        :model_data="createModel"
        @save-servico="createServico"
        @close="showCreatePopUp = false"
      />
    </div>

    <hr class="my-6">

    <div class="w-full">
      <p class="font-bold">Legenda de Estados:</p>
    </div>

    <template v-for="(color, chave) in colors" :key="chave">
      <div class="grid grid-cols-2 gap-4 sm:gap-20" v-if="!['pendente', 'rejeitado', 'cancelado', 'agendado'].includes(chave)">
        <div class="my-1">
          <p class="w-full h-full rounded" :style="{ backgroundColor: color }"></p>
        </div>
        <div>
          <p class="">{{ legendaLabels[chave] || chave }}</p>
        </div>
      </div>
    </template>


  <notificacaoes_agendamentos
      ref="notificacoesRef"
      :ordem_servico_id="notificacoesOrdemServicoId"
      :show="showNotificacoesModal"
      :cancel_disabled="notificacoesCancelDisabled"
      @close="fecharNotificacoes"
      @refresh="getPlaneamento"
    />

    <!-- Modal de Info do Serviço -->
    <div v-if="showInfoModal" class="rota-modal-overlay" @click.self="showInfoModal = false">
      <div class="info-modal-card">
        <div class="rota-modal-header">
          <h3><i class="fa-solid fa-circle-info mr-2 text-blue-400"></i>Informações do Serviço</h3>
          <button type="button" @click="showInfoModal = false">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="info-modal-body">
          <div class="info-modal-col">
            <h2 class="text-base font-bold mb-3 text-white">Informações Adicionais</h2>
            <label class="block mb-1 text-sm font-medium text-gray-300">Observações Negócio</label>
            <textarea rows="4" disabled
              class="block p-2.5 my-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300">{{ infoCartao.negocio_descricao }}</textarea>
            <!-- Descrição Serviço (negocio.descricao) — desativado a pedido, mantido comentado
            <hr class="my-3 border-gray-600">
            <label class="block mb-1 text-sm font-medium text-gray-300">Descrição Serviço</label>
            <textarea v-model="infoObservacoes" rows="4"
              class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"></textarea>
            -->
            <hr class="my-3 border-gray-600">
            <label class="block mb-1 text-sm font-medium text-gray-300">Observação Interna</label>
            <textarea v-model="infoCartao.observacao_interna" rows="4"
              class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"></textarea>
            <button @click="gravarInfoObservacoes"
              class="mt-4 px-4 py-2 rounded-lg text-sm bg-green-600 hover:bg-green-500 text-white">
              Guardar
            </button>
          </div>
          <div class="info-modal-col">
            <h2 class="text-base font-bold mb-3 text-white">Artigos Potenciados</h2>
            <div class="info-modal-table-wrap">
              <table class="w-full text-sm text-left text-gray-400">
                <thead class="text-xs text-gray-300 uppercase bg-gray-700">
                  <tr>
                    <th class="px-4 py-2">Artigo</th>
                    <th class="px-4 py-2">Quantidade</th>
                    <th class="px-4 py-2">Desconto</th>
                    <th class="px-4 py-2">Preço</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in infoCartao.itens_validacao" :key="item.id"
                    class="bg-gray-800 border-b border-gray-700 hover:bg-gray-600">
                    <td class="px-4 py-2 font-medium text-white">{{ item.equipamento_nome }}</td>
                    <td class="px-4 py-2">{{ item.quantidade }}</td>
                    <td class="px-4 py-2">{{ item.desconto_percentual }}</td>
                    <td class="px-4 py-2">{{ item.preco }}</td>
                  </tr>
                  <tr v-if="infoCartao.itens_validacao.length === 0">
                    <td colspan="4" class="px-4 py-4 text-center text-gray-500">Sem artigos</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Rota do Técnico -->
    <div v-if="showRotaModal" class="rota-modal-overlay" @click.self="fecharRotaModal">
      <div class="rota-modal-card">
        <div class="rota-modal-header">
          <div class="min-w-0">
            <h3 class="truncate"><i class="fas fa-route mr-2 text-purple-400"></i>Rota — {{ nomeTecnicoSelecionado }}</h3>
            <p class="truncate">{{ rotaSubtitulo }}</p>
          </div>
          <button type="button" @click="fecharRotaModal" title="Fechar">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="rota-modal-body">
          <div ref="rotaMapaEl" class="rota-mapa"></div>
          <div class="rota-legenda">
            <div v-if="rotaCarregando" class="text-center text-gray-300 mt-4">
              <div class="animate-spin w-7 h-7 border-4 border-purple-500 border-t-transparent rounded-full mx-auto mb-2"></div>
              A calcular rotas…
            </div>
            <template v-else>
              <p class="font-bold text-gray-100 mb-1">Locais de instalação por rota</p>
              <p class="text-[11px] text-gray-400 mb-2">
                <i class="fas fa-wand-magic-sparkles mr-1 text-purple-300"></i>Ordem otimizada para menor deslocação. Os números indicam a ordem sugerida do percurso.
              </p>
              <div v-if="rotasInfo.length === 0" class="text-gray-400 text-xs mt-2">
                Sem locais de instalação com coordenadas neste período.
              </div>

              <div v-for="(r, idx) in rotasInfo" :key="idx" class="rota-dia">
                <div class="rota-dia-cab">
                  <span class="rota-cor" :style="{ background: r.cor }"></span>
                  <strong class="text-gray-100">{{ r.dia }}</strong>
                  <span v-if="r.otimizada" class="text-[10px] text-purple-300 ml-auto">otimizada</span>
                </div>
                <div class="text-gray-400 text-[11px] mb-1">
                  {{ r.paragens }} {{ r.paragens === 1 ? 'local' : 'locais' }}
                  <template v-if="r.distancia"> · <i class="fas fa-road text-purple-300"></i> {{ r.distancia }} ·
                    <i class="fas fa-clock text-purple-300"></i> {{ r.duracao }}</template>
                </div>
                <ol class="rota-paradas">
                  <li v-for="p in r.paradas" :key="p.ordem">
                    <span class="rota-num" :style="{ background: r.cor }">{{ p.ordem }}</span>
                    <div class="min-w-0">
                      <div class="rota-local">{{ p.local }}</div>
                      <div class="rota-cliente">{{ p.cliente }}<i v-if="p.sub_cliente_bloqueado" class="fa-solid fa-lock" style="color:#ef4444; margin-left:3px" title="Sub-cliente bloqueado"></i><span v-if="p.hora"> · {{ p.hora }}</span></div>
                    </div>
                  </li>
                </ol>
              </div>

              <div v-if="rotaSemCoordLista.length > 0" class="rota-sem-coord">
                <p class="rota-sem-coord-titulo">
                  <i class="fas fa-location-pin-lock mr-1"></i>Sem coordenadas ({{ rotaSemCoordLista.length }})
                </p>
                <p class="text-[11px] text-gray-400 mb-2">
                  Estes locais de instalação não são traçados no mapa. Defina as coordenadas em <strong>Mapa Serviços</strong>.
                </p>
                <div v-for="(s, i) in rotaSemCoordLista" :key="i" class="sem-coord-item">
                  <div class="rota-local">{{ s.local }}</div>
                  <div class="rota-cliente">{{ s.cliente }}<i v-if="s.sub_cliente_bloqueado" class="fa-solid fa-lock" style="color:#ef4444; margin-left:3px" title="Sub-cliente bloqueado"></i></div>
                  <div v-if="s.morada" class="sem-coord-morada">
                    <i class="fas fa-location-dot mr-1"></i>{{ s.morada }}
                  </div>
                  <div class="sem-coord-meta">{{ s.data }} · <span class="capitalize">{{ s.status }}</span></div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, nextTick } from "vue";
import { toast } from "vue3-toastify";
import axios from "axios";
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import popUp from "@/components/popUps/planeamentoPopUp.vue";
import createPopUp from "@/components/popUps/planeamentoCreatePopUp.vue";
import notificacaoes_agendamentos from "../dialog/notificacaoes_agendamentos.vue";
import { pt } from "date-fns/locale";
import { locale } from "core-js";
import fontawesome from "@fortawesome/fontawesome-free/css/all.css";
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useTheme } from "@/composables/useTheme";
import { normalizarDataBD, parseDataBD } from "@/utils/dataBD";

const props = defineProps({
  monthOnly: { type: Boolean, default: false },
});

const emit = defineEmits(['confirm', 'refreshTable', 'transfer-service']);

const { theme } = useTheme();

const baseURl = process.env.VUE_APP_URL_BASE;
const tecnicos = ref([]);
const select_tecnico = ref("");
const tecnico_search = ref("");
const tecnicoDropdownOpen = ref(false);
const tecnicoDropdownRef = ref(null);
const calendarRef = ref(null);
const currentDateRange = ref({ start_date: null, end_date: null });
const search_text = ref("");

const planeamento_data = ref([]);

// ---- Rota do técnico (mapa) ----
const showRotaModal = ref(false);
const rotaCarregando = ref(false);
const rotasInfo = ref([]);
const rotaSemCoord = ref(0);
const rotaSemCoordLista = ref([]);
const rotaSubtitulo = ref("");
const rotaMapaEl = ref(null);
let mapaRota = null;
let camadaRotas = null;

const notificacoesRef = ref(null);
const showNotificacoesModal = ref(false);
const notificacoesOrdemServicoId = ref(null);
const notificacoesCancelDisabled = ref(false);

const showInfoModal = ref(false);
const infoNegocioId = ref(null);
const infoOrdemServicoId = ref(null);
const infoObservacoes = ref('');
const infoCartao = ref({ negocio_descricao: '', observacao_interna: '', itens_validacao: [] });

const modalModel = ref([]);
const modalData = ref({});
const modalSetData = ref({});
const planeamento_descricao = ref({});
const popUpEdit_mode = ref(true);
const showModal = ref(false);
const showPopUp = ref(false);
const showCreatePopUp = ref(false);
const showOSDateTimePopUp = ref(false);
const createModel = ref({});

const valores = ref(0);
const objectivo = ref(0);
const mostrar_agendar = ref(false);

const selectedEventIds = ref(new Set());
const hasSelectedEvents = computed(() => selectedEventIds.value.size > 0 && !!select_tecnico.value);
const selectedCount = computed(() => selectedEventIds.value.size);
const allEligibleSelected = computed(() => {
  const eligible = planeamento_data.value.filter(p => p.status !== 'fechado');
  return eligible.length > 0 && eligible.every(p => selectedEventIds.value.has(String(p.id)));
});

const userValencias = ref([]);
const canDesagendarConfirmed = computed(() =>
  userValencias.value.some(v => v.tpValencia?.nome === 'Gerir OS Confirmadas')
);

let dados_agendar = [];
let popoverObserver = null;


const colors = {
  pendente: "#dbb73e",
  atribuido: "#00008B",
  agendado: "#ff9b05",
  cancelado: "#999999",
  rejeitado: "#970000",
  interrompido: "orange",
  confirmado: "#01BA32",
  fechado: "black",
  fechadoTemporario: "#5B21B6",
};

// nomes legíveis para a legenda (as restantes chaves aparecem como estão)
const legendaLabels = {
  fechadoTemporario: "Execução",
};

// Uma OS fechada cujo relatório ainda é temporário distingue-se pela cor
function corDoEvento(item) {
  if (item.status === "fechado" && !item.relatorio_definitivo) {
    return colors.fechadoTemporario;
  }
  return colors[item.status];
}

// estados que entram na rota (visitas atribuídas ou agendadas/confirmadas)
const ROTA_STATUS = ["atribuido", "agendado", "confirmado"];
// uma cor por dia da rota
const ROTA_CORES = ["#8b5cf6", "#06b6d4", "#f59e0b", "#ec4899", "#22c55e", "#ef4444", "#3b82f6", "#a855f7"];

// Nome do técnico, com sufixo (inativo) para quem não está ativo
function nomeTecnico(tecnico) {
  if (!tecnico) return "";
  const ativo = String(tecnico.status || "").trim().toLowerCase() === "ativo";
  return ativo ? String(tecnico.nome || "") : `${tecnico.nome || ""} (inativo)`;
}

const nomeTecnicoSelecionado = computed(
  () => nomeTecnico(tecnicos.value.find(t => t.id === select_tecnico.value)) || "—"
);

const tecnicosOrdenados = computed(
  () => [...tecnicos.value].sort(
    (a, b) => String(a.nome || "").localeCompare(String(b.nome || ""), "pt", { sensitivity: "base" })
  )
);

const filteredTecnicos = computed(() => {
  if (!tecnico_search.value) return tecnicosOrdenados.value;
  const q = tecnico_search.value.toLowerCase();
  return tecnicosOrdenados.value.filter(t => nomeTecnico(t).toLowerCase().includes(q));
});

function selectTecnico(tecnico) {
  select_tecnico.value = tecnico.id;
  tecnico_search.value = nomeTecnico(tecnico);
  tecnicoDropdownOpen.value = false;
  clearSelection();
  onChangeTecnico();
}

function clearTecnico() {
  select_tecnico.value = "";
  tecnico_search.value = "";
  tecnicoDropdownOpen.value = false;
  clearSelection();
  onChangeTecnico();
}

function handleClickOutside(e) {
  if (tecnicoDropdownRef.value && !tecnicoDropdownRef.value.contains(e.target)) {
    tecnicoDropdownOpen.value = false;
    if (select_tecnico.value) {
      tecnico_search.value = nomeTecnico(tecnicos.value.find(t => t.id === select_tecnico.value));
    }
  }
}

onMounted(() => {
  getTecnicos();
  document.addEventListener('click', handleClickOutside);

  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.id) {
      axios.get(`${baseURl}/api/v1/utilizadorvalencia/s/utilizador_id/${user.id}/?exact=true`)
        .then(res => { userValencias.value = res.data.data || []; })
        .catch(() => { userValencias.value = []; });
    }
  } catch { userValencias.value = []; }

  nextTick(() => {
    const fcRoot = calendarRef.value?.$el;
    if (fcRoot) {
      popoverObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1 && node.classList?.contains('fc-popover')) {
              if (props.monthOnly) {
                // In drag mode, keep the popover inside the FC DOM so FullCalendar
                // can maintain parentNode references during drag-and-drop.
                node.style.zIndex = '99999';
                node.style.position = 'absolute';
              } else {
                requestAnimationFrame(() => {
                  const rect = node.getBoundingClientRect();
                  document.body.appendChild(node);
                  node.style.position = 'fixed';
                  node.style.top = rect.top + 'px';
                  node.style.left = rect.left + 'px';
                  node.style.zIndex = '99999';
                });
              }
            }
          }
        }
      });
      popoverObserver.observe(fcRoot, { childList: true, subtree: true });
    }
  });
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
  if (popoverObserver) {
    popoverObserver.disconnect();
    popoverObserver = null;
  }
  document.querySelectorAll('.fc-popover').forEach(el => el.remove());
  if (mapaRota) {
    mapaRota.remove();
    mapaRota = null;
    camadaRotas = null;
  }
});

function getTecnicos() {
  axios.get(`${baseURl}/api/v1/utilizador/tecnicos/`)
    .then((response) => {
      tecnicos.value = response.data.data;
    })
    .catch((error) => {
      console.error("Erro ao buscar técnicos:", error);
    });
}

// Quando o técnico muda:
function onChangeTecnico() {
  // Só busca eventos se já tivermos o range do calendário
  if (currentDateRange.value.start_date) {
    getPlaneamento();
  }
}

function pesquisar_calendario() {
  // console.log("Pesquisar por:", search_text.value);
  getPlaneamento();

}

// Função para buscar o planeamento com base no técnico e nas datas visíveis
function getPlaneamento() {

  if (!currentDateRange.value.start_date) return;

  const calendarApi = calendarRef.value?.getApi?.();
  if (!calendarApi) {
    console.warn("Calendário ainda não está disponível");
    return;
  }

  if (!select_tecnico.value && props.monthOnly) {
    calendarApi.removeAllEvents();
    planeamento_data.value = [];
    return;
  }

  const { start_date, end_date } = currentDateRange.value;

  axios.get(`${baseURl}/api/v1/planeamento/data/tecnico/${select_tecnico.value ? select_tecnico.value : 0}/`, {
    params: { start_date, end_date, pesquisa: search_text.value }
  })
    .then((response) => {

      // Mantém a hora literal da BD (ver utils/dataBD.js)
      response.data.data.forEach(item => {
        item.inicio = normalizarDataBD(item.inicio);
        item.fim = normalizarDataBD(item.fim);
      });

      planeamento_data.value = response.data.data.map(item => ({
        event_id: item.id,
        id: item.id,
        cliente_nome: item.cliente_nome,
        sub_cliente_bloqueado: item.sub_cliente_bloqueado,
        status: item.status,
        descricao: item.descricao,
        tecnico_nome: item.tecnico_nome,
        zona: item.zona,
        servico: item.servico,
        inicio: item.inicio,
        fim: item.fim,
        valor: item.valor_previsto,
        valor_sem_iva: item.valor_sem_iva,
        ordem_servico_id: item.ordem_servico_id,
        negocio_id: item.negocio_id,
        local_instalacao: item.local_instalacao,
        endereco_completo: item.endereco_completo,
        latitude: item.latitude,
        longitude: item.longitude,
        estado_decisao: item.estado_decisao,
        relatorio_definitivo: item.relatorio_definitivo,
      }));

      const events = response.data.data.map(item => ({
        id: item.id,
        title: item.cliente_nome + " - " + item.local_instalacao + " (" + item.servico.nome + ")",
        start: item.inicio,
        end: item.fim,
        // allDay: item.todo_dia,
        extendedProps: {
          color: corDoEvento(item),
          descricao: item.descricao,
          cliente_nome: item.cliente_nome,
          sub_cliente_bloqueado: item.sub_cliente_bloqueado,
          local_instalacao: item.local_instalacao,
          morada: item.endereco_completo,
          valor: item.valor_previsto,
          valor_sem_iva: item.valor_sem_iva,
          status: item.status,
          descricao: item.descricao,
          tecnico: item.tecnico_nome,
          utilizador_id: item.utilizador_id,
          ordem_servico_id: item.ordem_servico_id,
          negocio_id: item.negocio_id,
          familia: item.familia,
          tpNegocio: item.tpNegocio,
          relatorio_definitivo: item.relatorio_definitivo,
          icon: item.icon,
          estado_decisao: item.estado_decisao,
        },
      }));


      calcularValoresObjectivo(select_tecnico.value, planeamento_data.value);
      calendarApi.removeAllEvents();
      calendarApi.addEventSource(events);
    })
    .catch((error) => {
      console.error("Erro ao buscar planeamento:", error);
    });
}

function calcularValoresObjectivo(tecnicoId, planeamentoData) {

  const view = calendarRef.value.getApi().view;
  let dias = 0;
  let valoresTotais = 0;
  mostrar_agendar.value = false;
  dados_agendar = [];

  // Os serviços que atravessam várias semanas aparecem também nas vistas
  // seguintes, mas o objetivo e o agendamento em massa só contam os que
  // começam dentro da vista atual (senão o mesmo valor era somado várias vezes).
  planeamentoData = planeamentoData.filter(item => {
    const inicio = new Date(item.inicio);
    return inicio >= view.activeStart && inicio < view.activeEnd;
  });

  if (view.type == "dayGridWeek") {
    dias = 5;
    planeamentoData = planeamentoData.filter(item => {
      if (item.status == "atribuido" ||
        item.status == "agendado" ||
        item.status == "confirmado" ||
        item.status == "transferido" ||
        item.status == "execução" ||
        item.status == "execucao" ||
        item.status == "interrompido" ||
        item.status == "fechado"
      ) {
        valoresTotais += parseFloat(item.valor) || 0;
        dados_agendar.push({ tecnico_id: tecnicoId, item: item });
        return true;
      }
      return false;
    });
  } else if (view.type == "dayGridDay") {
    dias = 1;
    planeamentoData = planeamentoData.filter(item => {
      if (item.status == "atribuido" ||
        item.status == "agendado" ||
        item.status == "confirmado" ||
        item.status == "transferido" ||
        item.status == "execução" ||
        item.status == "execucao" ||
        item.status == "interrompido" ||
        item.status == "fechado"
      ) {
        valoresTotais += parseFloat(item.valor) || 0;
        dados_agendar.push({ tecnico_id: tecnicoId, item: item });
        return true;
      }
      return false;
    });
  }

  let objetivoDiario = 0;
  const tecnico = tecnicos.value.find(t => t.id == tecnicoId);
  if (tecnico && tecnico.objetivoDiario) {
    objetivoDiario = parseFloat(tecnico.objetivoDiario) * dias;
  }
  objectivo.value = objetivoDiario;
  valores.value = valoresTotais.toFixed(2);

  if (valores.value >= objectivo.value && objetivoDiario > 0 && (view.type == "dayGridDay" || view.type == "dayGridWeek")) {
    mostrar_agendar.value = true;
  }
}

async function agendar_servicos() {
  // ✅ Só é possível confirmar planeamentos que estejam com status "atribuido".
  // O dados_agendar inclui outros estados (agendado, confirmado, etc.) apenas
  // para o cálculo do valor vs. objetivo, por isso filtramos aqui antes de enviar.
  const por_confirmar = dados_agendar.filter(
    (item) => item.item.status == "atribuido"
  );

  if (por_confirmar.length === 0) {
    toast("Não existem serviços atribuídos por confirmar!", {
      theme: "auto",
      type: "info",
      position: "top-center",
      autoClose: 2000,
    });
    return;
  }

  const updatePromises = []; // ✅ Criar array

  por_confirmar.forEach((item) => {
    // ✅ Adicionar Promise à array SEM await no forEach
    updatePromises.push(
      update(
        `${baseURl}/api/v1/planeamento/agendar/${item.item.id}/`,
        {
          ...item,
          status: "confirmado",
        }
      )
    );

  });

  try {
    const results = await Promise.all(updatePromises);

    // ✅ Atualizar status do ordemServico para cada resultado
    const ordemServicoPromises = por_confirmar.map((item, index) => {
      return update(
        `${baseURl}/api/v1/ordemservico/agendar/${item.item.ordem_servico_id}/`,
        {
          status: "confirmado",
        }
      );
    });

    await Promise.all(ordemServicoPromises);

    toast("Todos os serviços foram confirmados!", {
      theme: "auto",
      type: "success",
      position: "top-center",
      autoClose: 2000,
    });

    getPlaneamento(); // Recarregar eventos
    emit('confirm');
  } catch (error) {
    console.error("Erro ao agendar serviços:", error);
    toast("Erro ao agendar alguns serviços!", {
      theme: "auto",
      type: "error",
      position: "top-center",
      autoClose: 2000,
    });
  }
}

// Atualiza o intervalo de datas sempre que muda a view
const getDatasCalendario = (info) => {
  currentDateRange.value = {
    start_date: info.startStr,
    end_date: info.endStr,
  };

  // Atualiza automaticamente os eventos quando o utilizador muda de mês/semana
  getPlaneamento();
};

const handleDateClick = (info) => {
  if (!select_tecnico.value) {
    toast("Selecione um técnico para adicionar um serviço!", {
      theme: "auto",
      type: "warning",
      position: "top-center",
      autoClose: 2000,
    });
    return;
  }

  const tecnico = tecnicos.value.find((t) => t.id === select_tecnico.value);
  if (!tecnico) {
    toast("Técnico selecionado não foi encontrado!", {
      theme: "auto",
      type: "warning",
      position: "top-center",
      autoClose: 2000,
    });
    return;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const clickedDate = new Date(info.date);
  const dateOnly = new Date(clickedDate);
  dateOnly.setHours(0, 0, 0, 0);

  if (dateOnly < today) {
    toast("Não é permitido agendar serviços no passado!", {
      theme: "auto",
      type: "warning",
      position: "top-center",
      autoClose: 2000,
    });
    return;
  }

  let inicio;
  let fim;
  if (info.allDay) {
    inicio = new Date(clickedDate);
    inicio.setHours(9, 0, 0, 0);
    fim = new Date(clickedDate);
    fim.setHours(11, 0, 0, 0);
  } else {
    inicio = new Date(clickedDate);
    fim = new Date(clickedDate);
    fim.setHours(fim.getHours() + 2);
  }

  createModel.value = {
    inicio: formatDateTime(inicio),
    fim: formatDateTime(fim),
    tecnico: {
      nome: tecnico.nome,
      id: tecnico.id,
      valor: tecnico.objetivoDiario || 0,
    },
    local: { nome: "", id: 0 },
    tpNegocio: { nome: "", id: 0 },
    familia: { nome: "", id: 0 },
    servico: { nome: "", id: 0 },
    modoContato: { nome: "", id: 0 },
    quantidade: 1,
    valor: 0,
    desconto_percentual: 0,
  };
  showCreatePopUp.value = true;
};

const createServico = async (data) => {
  try {
    const res = await axios.post(
      `${baseURl}/api/v1/ordemservico/planeamento/registrar/normal/`,
      data
    );
    const ordemServicoBasic = res?.data?.data;
    if (!ordemServicoBasic?.id) {
      toast("Erro ao criar serviço!", {
        theme: "auto",
        type: "error",
        position: "top-center",
        autoClose: 1000,
      });
      return;
    }

    const servicoRes = await axios.get(
      `${baseURl}/api/v1/ordemservico/${ordemServicoBasic.id}/`
    );
    const servico = servicoRes?.data?.data?.data || servicoRes?.data?.data;

    const titulo = `Serviço: ${servico?.Familia?.nome || data.servico?.nome || ""}\nCliente: ${servico?.cliente?.cliente || servico?.cliente?.nome || ""}\nSubCliente: ${servico?.subCliente?.nome || ""}\nLocal: ${servico?.Negocio?.localInstalacao || data.local?.nome || ""}\nValor: ${servico?.valor_previsto || 0}`;
    const planeamentoData = {
      event_id: `${Date.now()}-${ordemServicoBasic.id}`,
      titulo,
      inicio: data.inicio,
      fim: data.fim,
      zona_id: 0,
      servico_id: ordemServicoBasic.id,
      descricao: servico?.Negocio?.descricao || "",
      utilizador_id: data.tecnico.id,
      tecnico_id: data.tecnico.id,
      ordemServico_id: ordemServicoBasic.id,
      data: new Date().toISOString(),
      valor: servico?.valor_previsto || 0,
      status: "atribuido",
    };

    try {
      await axios.post(
        `${baseURl}/api/v1/planeamento/registrar/`,
        planeamentoData
      );
    } catch (planErr) {
      console.error("Erro ao criar planeamento:", planErr);
      toast(
        planErr?.response?.data?.message ||
          "Serviço criado mas erro ao criar planeamento!",
        {
          theme: "auto",
          type: "warning",
          position: "top-center",
          autoClose: 2000,
        }
      );
    }

    toast("Serviço criado com sucesso!", {
      theme: "auto",
      type: "success",
      position: "top-center",
      autoClose: 1000,
    });
    showCreatePopUp.value = false;
    getPlaneamento();
    emit("refreshTable");
  } catch (error) {
    console.error("Erro ao criar serviço:", error);
    const backendMsg =
      error?.response?.data?.message ||
      (typeof error?.response?.data === "string" ? error.response.data : null);
    toast(backendMsg || "Erro ao criar serviço!", {
      theme: "auto",
      type: "error",
      position: "top-center",
      autoClose: 2000,
    });
  }
};

const clicarEvento = (info) => {
  if (info.jsEvent?.target?.classList?.contains('event-checkbox')) return;
  const event = info.event;
  const index = planeamento_data.value.findIndex(
    (item) => item.event_id === event.id
  );
  if (index !== -1) {

    const statusList = [];
    if (statusList.includes(planeamento_data.value[index].status)) {
      toast("Não é permitido editar este evento!", {
        theme: "auto",
        type: "warning",
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }
  }
  editEvent(event);
};

const editEvent = async (e) => {
  console.log("Edit event", e);
  modalModel.value = [
    // { name: "Serviço", id: "service" },
    { name: "Servico", id: "Servico", type: "text", disabled: true },
    { name: "Família", id: "Familia", type: "text", disabled: true },
    { name: "Tipo de Negócio", id: "TpNegocio", type: "text", disabled: true },
    { name: "Inicio", id: "start", type: "datetime", disabled: true },
    { name: "Fim", id: "end", type: "datetime", disabled: true },
    { name: "Zona", id: "location" },
    { name: "Descrição", id: "description", type: "textarea" },
    { name: "Cliente", id: "Cliente", type: "text", disabled: true },
    { name: "Local", id: "Local", type: "text", disabled: true },
    { name: "tecnico", id: "tecnico", type: "text", disabled: true },
    { name: "Endereço", id: "Endereco", type: "text", disabled: true },
    { name: "Valor", id: "Valor", type: "text", disabled: true },
    { name: "Status", id: "status", type: "text", disabled: true },
  ];
  modalData.value = {
    ...e._def,
    Servico: e._def.extendedProps.descricao,
    Familia: e._def.extendedProps.familia?.nome || "N/A",
    TpNegocio: e._def.extendedProps.tpNegocio?.nome || "N/A",
    start: formatDateTime(e.start),
    end: formatDateTime(e.end),
    Cliente: e._def.extendedProps.cliente_nome,
    Local: e._def.extendedProps.local_instalacao,
    Endereco: e._def.extendedProps.morada,
    tecnico: e._def.extendedProps.tecnico,
    Valor: e._def.extendedProps.valor,
    status: e._def.extendedProps.status,
    description: e._def.extendedProps.descricao,
  };

  modalSetData.value = {
    zona:
      e.location === ""
        ? { id: 0, nome: "N/A" }
        : planeamento_data.value.find((item) => item.event_id === e.id)
          ?.zona || { id: 0, nome: "N/A" },
    servico:
      e.service === ""
        ? { id: 0, nome: "N/A" }
        : planeamento_data.value.find((item) => item.event_id === e.id)
          ?.servico || { id: 0, nome: "N/A" },
  };
  planeamento_descricao.value = {
    planeamento_id: e.id,
    descricao: e.description,
  };
  //showPopUp.value = true;
  if (
    e.status == "confirmado" ||
    e.status == "fechado" ||
    e.status == "rejeitado" ||
    e.status == "cancelado" ||
    e.status == "interrompido" ||
    e.status == "pendente"
  ) {

    popUpEdit_mode.value = false;
  } else {
    popUpEdit_mode.value = true;
  }
  showModal.value = true;
};

const formatDateTime = (date) => {
  if (!date) return '';

  const dateObj = date instanceof Date ? date : new Date(date);

  if (isNaN(dateObj.getTime())) {
    console.error('Data inválida:', date);
    return '';
  }

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  const hours = String(dateObj.getHours()).padStart(2, '0');
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};


const fecharModal = () => {
  showModal.value = false;
  // calendarRef.value.control.clearSelection();
};

const calendarOptions = {
  themeSystem: 'standard', // mantém o tema base
  dayHeaderClassNames: ['bg-slate-800', 'text-slate-200'],
  dayCellClassNames: ['bg-slate-900', 'text-slate-200'],
  eventClassNames: ['bg-blue-600', 'text-white', 'rounded'],
  plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
  locale: pt,
  initialView: "dayGridMonth",
  dayMaxEventRows: 2,
  headerToolbar: {
    left: "title",
    center: "",
    right: props.monthOnly ? "prev,next,today" : "prev,next,today,dayGridMonth,dayGridWeek,dayGridDay",
  },
  editable: true,
  droppable: props.monthOnly,
  selectable: true,
  dateClick: handleDateClick,
  eventClick: clicarEvento,
  eventDrop: event_drag_drop,
  eventReceive: (info) => {
    if (!props.monthOnly) return;

    const droppedDate = new Date(info.event.start);
    droppedDate.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (droppedDate < today) {
      toast("Não é possível transferir um serviço para uma data no passado!", {
        type: "warning", position: "top-center", autoClose: 2000,
      });
      getPlaneamento();
      emit("transfer-service");
      return;
    }

    const status = info.event.extendedProps.status;
    if (status !== "atribuido") {
      toast(`Não é possível transferir um serviço no estado "${status}". Apenas serviços Atribuídos podem ser transferidos.`, {
        type: "warning", position: "top-center", autoClose: 3000,
      });
      getPlaneamento();
      emit("transfer-service");
      return;
    }

    const targetTecnicoId = select_tecnico.value;
    if (!targetTecnicoId) {
      toast("Selecione um técnico neste calendário antes de transferir!", {
        type: "warning", position: "top-center", autoClose: 2000,
      });
      getPlaneamento();
      emit("transfer-service");
      return;
    }

    const planeamentoId = info.event.id;
    const ordemServicoId = info.event.extendedProps.ordem_servico_id;
    const newStart = formatDateTime(info.event.start);
    const newEnd = info.event.end ? formatDateTime(info.event.end) : newStart;

    axios.put(`${baseURl}/api/v1/planeamento/editar/${planeamentoId}/`, {
      utilizador_id: targetTecnicoId,
      inicio: newStart,
      fim: newEnd,
    })
      .then(() => {
        if (!ordemServicoId) return Promise.resolve();
        return Promise.all([
          axios.put(`${baseURl}/api/v1/ordemservico/editar/${ordemServicoId}/`, {
            utilizador_id: targetTecnicoId,
          }),
          axios.put(`${baseURl}/api/v1/ordemservico/editar_data/${ordemServicoId}/`, {
            data_inicio: newStart,
            data_fim: newEnd,
          }),
        ]);
      })
      .then(() => {
        toast("Serviço transferido com sucesso!", {
          type: "success", position: "top-center", autoClose: 2000,
        });
        getPlaneamento();
        emit("transfer-service");
      })
      .catch(() => {
        toast("Erro ao transferir serviço!", {
          type: "error", position: "top-center", autoClose: 2000,
        });
        // Same issue as above — refresh both calendars from the backend.
        getPlaneamento();
        emit("transfer-service");
      });
  },
  datesSet: (info) => {
    getDatasCalendario(info);
    // Ajusta dayMaxEventRows conforme a view
    const calendarApi = calendarRef.value?.getApi();
    if (calendarApi) {
      const viewType = info.view.type;
      if (viewType === 'dayGridWeek' || viewType === 'dayGridDay') {
        calendarApi.setOption('dayMaxEventRows', false);
      } else {
        calendarApi.setOption('dayMaxEventRows', 2);
      }
    }
  }, // Atualiza o intervalo de datas visíveis

  events: planeamento_data.value,
  eventContent: function (arg) {
    const icon = arg.event.extendedProps.icon || '';
    const title = arg.event.title;
    const id = arg.event.extendedProps.ordem_servico_id;
    const bloqueado = arg.event.extendedProps.sub_cliente_bloqueado;
    const eventId = String(arg.event.id);
    let html = '';

    if (select_tecnico.value && arg.event.extendedProps.status !== 'fechado') {
      const isChecked = selectedEventIds.value.has(eventId);
      html += `<input type="checkbox" class="event-checkbox" data-event-id="${eventId}" ${isChecked ? 'checked' : ''} style="cursor:pointer;min-width:12px;height:12px;flex-shrink:0;margin-right:3px;vertical-align:middle;accent-color:#3b82f6">`;
    }

    if (icon) {
      html += `<span data-modal-target="default-modal" data-modal-toggle="default-modal" class="notification-icon text-sm cursor-pointer hover:scale-110 transition-transform"
                   data-ordem-servico-id="${id}"
                   title="Ver notificações">
               ${icon}
             </span>`;
    }
    if (bloqueado) {
      html += `<i class="fa-solid fa-lock" style="color:#ef4444; margin-right:3px" title="Sub-cliente bloqueado"></i>`;
    }
    html += `<span class="fc-event-title truncate">${title}</span>`;
    return { html: html };
  },
  eventDidMount: function (info) {
    info.el.style.backgroundColor = info.event.extendedProps.color || '#ff9b05';
    info.el.style.color = '#fff';
    info.el.addEventListener("contextmenu", (jsEvent) => {
      showContextMenu(info.event, jsEvent);
    });

    const iconElement = info.el.querySelector('.notification-icon');
    if (iconElement) {
      iconElement.addEventListener('click', (e) => {
        e.stopPropagation();
        const ordemServicoId = iconElement.getAttribute('data-ordem-servico-id');
        ver_notificacao(ordemServicoId);
      });
    }

    const checkbox = info.el.querySelector('.event-checkbox');
    if (checkbox) {
      checkbox.addEventListener('click', (e) => {
        e.stopPropagation();
        const eid = String(info.event.id);
        const newSet = new Set(selectedEventIds.value);
        if (checkbox.checked) {
          newSet.add(eid);
        } else {
          newSet.delete(eid);
        }
        selectedEventIds.value = newSet;
      });
    }
  },
};

function ver_notificacao(id) {
  console.log("Ver notificações para a ordem de serviço ID:", id);
  // Agendamentos já iniciados (fechado/interrompido) não podem ser cancelados
  const servico = planeamento_data.value.find(
    (p) => String(p.ordem_servico_id) === String(id)
  );
  notificacoesCancelDisabled.value = ["fechado", "interrompido"].includes(
    servico?.servico?.status
  );
  notificacoesOrdemServicoId.value = id;
  showNotificacoesModal.value = true;
}


const fecharNotificacoes = () => {
  showNotificacoesModal.value = false;
  notificacoesOrdemServicoId.value = null;
  notificacoesCancelDisabled.value = false;
};

async function event_drag_drop(info) {
  const event = info.event;

  if (event._def.extendedProps.status == "atribuido") {
    // event.start/end (API pública) são Date locais reais. Não usar
    // event._instance.range, que guarda a hora de parede nos campos UTC e
    // deslocaria o horário gravado pelo offset do fuso do utilizador.
    const novoInicio = formatDateTime(event.start);
    const novoFim = event.end ? formatDateTime(event.end) : novoInicio;

    try {

      let response = await update(
        `${baseURl}/api/v1/planeamento/editar/${event.id}/`,
        {
          inicio: novoInicio,
          fim: novoFim,
        }
      );

      if (response) {
        let responde_ordem_servico = await update(
          `${baseURl}/api/v1/ordemservico/editar_data/${event._def.extendedProps.ordem_servico_id}/`,
          {
            data_inicio: novoInicio,
            data_fim: novoFim,
          }
        );

        if (responde_ordem_servico) {
          toast("Datas atualizadas com sucesso!", {
            theme: "auto",
            type: "success",
            position: "top-center",
            autoClose: 2000,
          });
        }

      } else {
        throw new Error("Resposta inválida ao atualizar o evento.");
      }

    } catch (error) {
      console.error("Erro ao atualizar o evento:", error);
      toast("Erro ao alterar o horário deste evento!", {
        theme: "auto",
        type: "error",
        position: "top-center",
        autoClose: 2000,
      });
      info.revert();
    }
  } else {
    toast("Só é permitido alterar o horário de serviços no estado Atribuído!", {
      theme: "auto",
      type: "warning",
      position: "top-center",
      autoClose: 2000,
    });
    info.revert();
  }

}

const gravarDadosPlaneamento = async (data, setData) => {
  // Validações iniciais
  if (!data.publicId) {
    console.warn("ID do evento não encontrado");
    toast("Erro: Evento inválido", {
      theme: "auto",
      type: "error",
      position: "top-center",
      autoClose: 2000,
    });
    showModal.value = false;
    return;
  }

  // Formatar datas
  data.start = formatDateTime(data.start);
  data.end = formatDateTime(data.end);
  data.location = setData.zona?.nome || "";
  data.service = setData.servico?.nome || "";

  // Validar datas formatadas
  if (!data.start || !data.end) {
    toast("Erro ao formatar datas", {
      theme: "auto",
      type: "error",
      position: "top-center",
      autoClose: 2000,
    });
    showModal.value = false;
    return;
  }

  // Obter API do calendário
  const calendarApi = calendarRef.value?.getApi();
  if (!calendarApi) {
    console.error("Calendário não disponível");
    showModal.value = false;
    return;
  }

  // Atualizar evento no calendário
  const event = calendarApi.getEventById(data.publicId);
  if (event) {
    event.setExtendedProp('descricao', data.description);
    event.setProp('title', `${data.Cliente} - ${data.Local} (${setData.servico?.nome || 'N/A'})`);
  }

  const index = planeamento_data.value.findIndex(
    (item) => item.event_id == data.publicId
  );

  if (index === -1) {
    console.warn("Planeamento não encontrado em planeamento_data");
    toast("Erro: Planeamento não encontrado!", {
      theme: "auto",
      type: "error",
      position: "top-center",
      autoClose: 2000,
    });
    showModal.value = false;
    return;
  }
  const planeamentoId = planeamento_data.value[index].id;

  try {
    const res = await update(
      `${baseURl}/api/v1/planeamento/editar/${planeamentoId}/`,
      {
        descricao: data.description,
        inicio: data.start,
        fim: data.end,
      }
    );

    if (res) {
      // Atualizar dados locais após sucesso
      planeamento_data.value[index] = {
        ...planeamento_data.value[index],
        descricao: data.description,
        inicio: data.start,
        fim: data.end,
      };

      toast("Planeamento atualizado com sucesso!", {
        theme: "auto",
        type: "success",
        position: "top-center",
        autoClose: 2000,
      });

      showModal.value = false;
      emit("refreshTable");
    } else {
      throw new Error("Resposta vazia do servidor");
    }
  } catch (error) {
    console.error("Erro ao atualizar planeamento:", error);

    // Reverter mudanças no calendário se falhar
    if (event) {
      const originalData = planeamento_data.value[index];
      event.setExtendedProp('descricao', originalData.descricao);
      event.setProp('title', `${data.Cliente} - ${data.Local} (${setData.servico?.nome || 'N/A'})`);
    }

    toast("Erro ao atualizar planeamento!", {
      theme: "auto",
      type: "error",
      position: "top-center",
      autoClose: 2000,
    });
  }
};

//eventos para click do botão direito do rato
function showContextMenu(event, jsEvent) {
  jsEvent.preventDefault();



  const planeamento = planeamento_data.value.find(
    (item) => item.event_id == event.id
  );

  if (!planeamento) {
    console.warn("Evento não encontrado em planeamento_data.");
    return;
  }

  const status = planeamento.status;

  const menuItems = [
    { text: "Informações", action: () => ver_info_servico(event) },
    { text: "Ver Negócio", action: () => ir_negocio(event) },
    // { text: "Confirmar", action: () => confirmar_servico(event), disabled: status !== "agendado" },
    // { text: "Cancelar", action: () => cancelar_servico(event, "cancelado"), disabled: ["ativo", "atribuido", "cancelado"].includes(status) },
    // { text: "Rejeitar", action: () => cancelar_servico(event, "rejeitado"), disabled: ["ativo", "atribuido", "rejeitado"].includes(status) },
    // { text: "Eliminar", action: () => eliminar_servico(event), disabled: status === "confirmado" },
    // { text: "Mudar Horário", action: () => mudar_horario(event.id), disabled: ["confirmado", "fechado", "rejeitado", "cancelado", "interrompido", "pendente"].includes(status) },
    { text: "Confirmar Agendamento", action: () => confirmar_agendamento(event), disabled: status != "confirmado" },
    { text: "Recusar Agendamento", action: () => recusar_agendamento(event), disabled: status != "confirmado" },
    { text: "Desalocar", action: () => desalocar(event), disabled: ["fechado", "rejeitado", "cancelado", "interrompido", "pendente", 'ativo', 'cancelado', 'agendado', 'confirmado', 'transferido'].includes(status) },
    { text: "Desagendar", action: () => desagendar(event), disabled: ["fechado", "rejeitado", "cancelado", "interrompido", "pendente", 'ativo', 'atribuido', 'cancelado'].includes(status) },

  ];

  if (status === "pendente") {
    menuItems.forEach((item) => (item.disabled = true));
  }

  createContextMenu(jsEvent.pageX, jsEvent.pageY, menuItems);
}

function createContextMenu(x, y, items) {
  const existing = document.querySelector("#custom-context-menu");
  if (existing) existing.remove();

  const menu = document.createElement("div");
  menu.id = "custom-context-menu";
  menu.style.position = "absolute";
  menu.style.top = `${y}px`;
  menu.style.left = `${x}px`;
  menu.style.background = "#2c2c2c";
  menu.style.color = "white";
  menu.style.borderRadius = "6px";
  menu.style.padding = "6px 0";
  menu.style.boxShadow = "0 2px 8px rgba(0,0,0,0.2)";
  menu.style.zIndex = "10000";
  menu.style.minWidth = "150px";

  items.forEach((item) => {
    const el = document.createElement("div");
    el.innerText = item.text;
    el.style.padding = "6px 12px";
    el.style.cursor = item.disabled ? "not-allowed" : "pointer";
    el.style.opacity = item.disabled ? "0.5" : "1";

    el.addEventListener("click", () => {
      if (!item.disabled) {
        item.action();
        menu.remove();
      }
    });

    menu.appendChild(el);
  });

  document.body.appendChild(menu);

  document.addEventListener("click", () => menu.remove(), { once: true });
}

function ir_negocio(event) {
  const planeamento = planeamento_data.value.find(
    (item) => item.event_id == event.id
  );

  if (planeamento && planeamento.negocio_id) {
    window.open(`./negocio/${planeamento.negocio_id}`, "_blank");
  } else {
    toast("Ordem de Serviço não associada!", {
      theme: "auto",
      type: "warning",
      position: "top-center",
      autoClose: 2000,
    });
  }
}

async function ver_info_servico(event) {
  const negocio_id = event._def.extendedProps.negocio_id;
  const familia_id = event._def.extendedProps.familia?.id || 0;
  const ordem_servico_id = event._def.extendedProps.ordem_servico_id;

  if (!negocio_id) {
    toast("Negócio não encontrado!", { type: "warning", position: "top-center", autoClose: 2000 });
    return;
  }

  try {
    const response = await axios.get(`${baseURl}/api/v1/planeamento/detalhes_servicos/${negocio_id}/${familia_id}/${ordem_servico_id}/`);
    const dados = response.data.data || {};
    infoCartao.value = {
      negocio_descricao: dados.negocio_descricao || '',
      observacao_interna: dados.observacao_interna || '',
      itens_validacao: dados.itens_validacao || [],
    };
    infoObservacoes.value = dados.negocio_descricao || '';
    infoNegocioId.value = negocio_id;
    infoOrdemServicoId.value = ordem_servico_id;
    showInfoModal.value = true;
  } catch (error) {
    console.error('Erro ao buscar detalhes do serviço:', error);
    toast("Erro ao carregar informações do serviço.", { type: "error", position: "top-center", autoClose: 2000 });
  }
}

async function gravarInfoObservacoes() {
  // Grava a observação interna (ordemServico). A gravação da descrição do
  // serviço (negocio.descricao) foi desativada a pedido — ver o bloco
  // comentado no template — mas o Promise.all fica pronto para reintegrar
  // essa chamada caso volte a ser necessária.
  try {
    await Promise.all([
      // axios.put(`${baseURl}/api/v1/planeamento/atualizar_observacoes/${infoNegocioId.value}/`, {
      //   observacoes: infoObservacoes.value,
      // }),
      axios.put(`${baseURl}/api/v1/ordemservico/editar/${infoOrdemServicoId.value}/`, {
        observacao_interna: infoCartao.value.observacao_interna,
      }),
    ]);
    toast("Observações atualizadas com sucesso!", { type: "success", position: "top-center", autoClose: 1000 });
    showInfoModal.value = false;
  } catch (error) {
    console.error('Erro ao atualizar observações:', error);
    toast("Erro ao atualizar observações.", { type: "error", position: "top-center", autoClose: 2000 });
  }
}

async function desalocar(event) {

  console.log("Desalocar evento:", event);
  await axios.delete(process.env.VUE_APP_URL_BASE + `/api/v1/planeamento/eliminar/${event.id}/`, {
    params: { eliminar: true }
  })
    .then(async (response) => {
      // Atualizar status do serviço
      await axios.put(process.env.VUE_APP_URL_BASE + `/api/v1/ordemservico/desalocar/${event._def.extendedProps.ordem_servico_id}/`).then(() => {
        getPlaneamento();
        emit("confirm");
        toast("Serviço desalocado! Poderá voltar a atribuí-lo", {
          "theme": "auto",
          "type": "success",
          "position": "top-center",
          "autoClose": 1000,
        });
      }).catch((error) => {
        console.error('Erro ao atualizar status do serviço:', error);
      });
    });
}

// Só 'confirmado'/'adiado' contam como decisão. 'pendente' (email enviado, à
// espera do cliente) pode ser decidido internamente: os endpoints bulk-confirm
// / bulk-reject atualizam essa mesma resposta do email, e a página pública do
// cliente fica bloqueada a partir daí (admin_approved preenchido).
function agendamentoJaDecidido(event) {
  return ["confirmado", "adiado"].includes(event._def.extendedProps.estado_decisao);
}

function emailPendente(event) {
  return event._def.extendedProps.estado_decisao === "pendente";
}

async function confirmar_agendamento(event) {
  if (agendamentoJaDecidido(event)) {
    toast("O serviço já foi decidido! Se quiser alterar, primeiro cancele o agendamento.", {
      theme: "auto",
      type: "warning",
      position: "top-center",
      autoClose: 2000,
    });
    return;
  }

  const avisoEmail = emailPendente(event)
    ? `<p class="text-left mb-3">Existe um email de confirmação enviado ao cliente ainda sem resposta. Ao confirmar, o cliente deixa de poder responder pelo email.</p>`
    : "";

  const { value: observacoes, isConfirmed } = await Swal.fire({
    title: 'Confirmar Agendamento',
    html: `
      <p class="text-left mb-3">Tem a certeza que deseja confirmar este agendamento?</p>
      ${avisoEmail}
      <textarea 
        id="swal-observacoes" 
        class=" w-full" 
        placeholder="Observações"
        rows="4"
        style="resize: vertical; min-height: 100px;"
      ></textarea>
    `,
    showCancelButton: true,
    confirmButtonText: 'Confirmar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#01BA32',
    cancelButtonColor: '#d33',
    focusConfirm: false,
    preConfirm: () => {
      const textarea = document.getElementById('swal-observacoes');
      const value = textarea.value.trim();

      // ✅ Validação
      if (!value) {
        Swal.showValidationMessage('Por favor, informe o motivo do cancelamento');
        return false;
      }
      return value;
    }
  });

  if (!isConfirmed ) {
    return;
  }

  try {
    await axios.post(`${process.env.VUE_APP_URL_BASE}/api/v1/ordemservico/bulk-confirm/`,
      {
        ordemservico_ids: [event._def.extendedProps.ordem_servico_id],
        admin_notes: observacoes || "Agendamento confirmado internamente.",
      }
    );

    getPlaneamento();
    emit("confirm");
    
    toast("Serviço confirmado com sucesso!", {
      theme: "auto",
      type: "success",
      position: "top-center",
      autoClose: 1000,
    });

  } catch (error) {
    console.error("Erro ao confirmar serviço:", error);
    toast("Ocorreu um erro ao confirmar o serviço", {
      theme: "auto",
      type: "error",
      position: "top-center",
      autoClose: 2000,
    });
  }

}

// Equivalente, feito por um utilizador interno, a quando o cliente clica
// "Adiar" no email de confirmação — usa o mesmo endpoint em massa que
// confirmar_agendamento(), mas para o desfecho 'adiado' em vez de
// 'confirmado' (ver OrdemServicoBulkRejectView no backend).
async function recusar_agendamento(event) {
  if (agendamentoJaDecidido(event)) {
    toast("O serviço já foi decidido! Se quiser alterar, primeiro cancele o agendamento.", {
      theme: "auto",
      type: "warning",
      position: "top-center",
      autoClose: 2000,
    });
    return;
  }

  const avisoEmail = emailPendente(event)
    ? `<p class="text-left mb-3">Existe um email de confirmação enviado ao cliente ainda sem resposta. Ao recusar, o cliente deixa de poder responder pelo email.</p>`
    : "";

  const { value: observacoes, isConfirmed } = await Swal.fire({
    title: 'Recusar Agendamento',
    html: `
      <p class="text-left mb-3">Tem a certeza que deseja recusar este agendamento? O cliente terá de ser contactado para marcar uma nova data.</p>
      ${avisoEmail}
      <textarea
        id="swal-observacoes"
        class=" w-full"
        placeholder="Motivo da recusa"
        rows="4"
        style="resize: vertical; min-height: 100px;"
      ></textarea>
    `,
    showCancelButton: true,
    confirmButtonText: 'Recusar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#d33',
    cancelButtonColor: '#6b7280',
    focusConfirm: false,
    preConfirm: () => {
      const textarea = document.getElementById('swal-observacoes');
      const value = textarea.value.trim();

      if (!value) {
        Swal.showValidationMessage('Por favor, informe o motivo da recusa');
        return false;
      }
      return value;
    }
  });

  if (!isConfirmed) {
    return;
  }

  try {
    await axios.post(`${process.env.VUE_APP_URL_BASE}/api/v1/ordemservico/bulk-reject/`,
      {
        ordemservico_ids: [event._def.extendedProps.ordem_servico_id],
        admin_notes: observacoes,
      }
    );

    getPlaneamento();
    emit("confirm");

    toast("Agendamento recusado com sucesso!", {
      theme: "auto",
      type: "success",
      position: "top-center",
      autoClose: 1000,
    });

  } catch (error) {
    console.error("Erro ao recusar agendamento:", error);
    toast("Ocorreu um erro ao recusar o agendamento", {
      theme: "auto",
      type: "error",
      position: "top-center",
      autoClose: 2000,
    });
  }
}

async function desagendar(event) {
  console.log("Desagendar evento:", event);

  if (event._def.extendedProps.icon) {
    toast("Não é possível desagendar! Primeiro cancele o agendamento .", {
      theme: "auto",
      type: "warning",
      position: "top-center",
      autoClose: 2000,
    });
    return; 
  }

  try {
    await axios.put(`${process.env.VUE_APP_URL_BASE}/api/v1/planeamento/desagendar/${event.id}/`);
    await axios.put(`${process.env.VUE_APP_URL_BASE}/api/v1/ordemservico/desagendar/${event._def.extendedProps.ordem_servico_id}/`);

    getPlaneamento();
    emit("confirm");
    toast("Serviço desalocado! Poderá voltar a atribuí-lo", {
      theme: "auto",
      type: "success",
      position: "top-center",
      autoClose: 1000,
    });

  } catch (error) {
    console.error("Erro ao eliminar / atualizar serviço:", error);
    toast("Ocorreu um erro ao desagendar o serviço", {
      type: "error",
    });
  }

}

function cancelar_servico(event, status) {
  console.log("Alterar status:", status, "para o evento", event.id);
  // exemplo de chamada API
  // await axios.put(`/api/v1/ordemservico/${event.id}/`, { status });
}

function confirmar_servico(event) {
  console.log("Confirmar evento:", event.id);
}

function eliminar_servico(event) {
  console.log("Eliminar evento:", event.id);
}

function mudar_horario(eventId) {
  console.log("Abrir popup para editar horário:", eventId);
}

// ---------- Rota do técnico ----------
function parseCoordRota(valor) {
  const n = parseFloat(String(valor ?? "").replace(",", "."));
  if (!isFinite(n) || n === 0 || Math.abs(n) > 180) return null;
  return n;
}

function pad2(n) {
  return String(n).padStart(2, "0");
}

function formatarDiaLabel(diaKey) {
  const [y, m, d] = diaKey.split("-").map(Number);
  const data = new Date(y, m - 1, d);
  const label = data.toLocaleDateString("pt-PT", { weekday: "short", day: "2-digit", month: "2-digit" });
  return label.charAt(0).toUpperCase() + label.slice(1);
}

function abrirRotaModal() {
  if (!select_tecnico.value) {
    toast("Selecione um técnico para ver a rota!", {
      theme: "auto", type: "warning", position: "top-center", autoClose: 2000,
    });
    return;
  }

  const view = calendarRef.value?.getApi()?.view;
  const tipoLabel = { dayGridDay: "Dia", dayGridWeek: "Semana", dayGridMonth: "Mês" }[view?.type] || "";
  rotaSubtitulo.value = `${tipoLabel}${view?.title ? " — " + view.title : ""}`;

  showRotaModal.value = true;
  nextTick(() => {
    setTimeout(() => {
      initMapaRota();
      tracarRotasTecnico();
    }, 120);
  });
}

function initMapaRota() {
  if (mapaRota) {
    mapaRota.remove();
    mapaRota = null;
  }
  mapaRota = L.map(rotaMapaEl.value, { center: [39.5, -8.0], zoom: 7 });
  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    maxZoom: 19,
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  }).addTo(mapaRota);
  camadaRotas = L.layerGroup().addTo(mapaRota);
  mapaRota.invalidateSize();
}

function criarMarcadorRota(numero, cor) {
  return L.divIcon({
    className: "rota-pin-wrapper",
    html: `<div class="rota-pin" style="background:${cor}">${numero}</div>`,
    iconSize: [28, 28],
    iconAnchor: [14, 14],
  });
}

async function tracarRotasTecnico() {
  if (!mapaRota) return;
  rotaCarregando.value = true;
  rotasInfo.value = [];
  rotaSemCoord.value = 0;
  rotaSemCoordLista.value = [];
  camadaRotas.clearLayers();

  // só visitas atribuídas/agendadas/confirmadas
  const relevantes = planeamento_data.value.filter(it => ROTA_STATUS.includes(it.status));

  const visitas = [];
  relevantes.forEach(it => {
    const lat = parseCoordRota(it.latitude);
    const lng = parseCoordRota(it.longitude);
    if (lat === null || lng === null) {
      // local de instalação sem coordenadas: não vai ao mapa, mas é listado em detalhe
      rotaSemCoordLista.value.push({
        local: it.local_instalacao || "—",
        cliente: it.cliente_nome || "—",
        sub_cliente_bloqueado: it.sub_cliente_bloqueado,
        morada: it.endereco_completo && it.endereco_completo !== "N/A" ? it.endereco_completo : "",
        status: it.status,
        data: it.inicio
          ? parseDataBD(it.inicio).toLocaleString("pt-PT", {
              day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
            })
          : "",
      });
    } else {
      visitas.push({ ...it, lat, lng });
    }
  });
  rotaSemCoord.value = rotaSemCoordLista.value.length;

  if (visitas.length === 0) {
    rotaCarregando.value = false;
    return;
  }

  // agrupa por dia (data do início)
  const grupos = {};
  visitas.forEach(v => {
    const d = parseDataBD(v.inicio);
    const key = `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
    (grupos[key] = grupos[key] || []).push(v);
  });

  const bounds = [];
  const diasOrdenados = Object.keys(grupos).sort();

  for (let idx = 0; idx < diasOrdenados.length; idx++) {
    const dia = diasOrdenados[idx];
    const cor = ROTA_CORES[idx % ROTA_CORES.length];
    // ponto de partida = primeira visita do dia por hora; o resto da ordem é
    // otimizado pelo OSRM (Trip / caixeiro-viajante) para minimizar a deslocação
    let lista = grupos[dia].sort((a, b) => parseDataBD(a.inicio) - parseDataBD(b.inicio));

    let distancia = null;
    let duracao = null;
    let otimizada = false;

    if (lista.length >= 2) {
      try {
        const coords = lista.map(v => `${v.lng},${v.lat}`).join(";");
        const resp = await fetch(`https://router.project-osrm.org/trip/v1/driving/${coords}?roundtrip=false&source=first&overview=full&geometries=geojson`);
        const dados = await resp.json();
        if (dados.code === "Ok" && dados.trips && dados.trips.length > 0) {
          // reordena as visitas pela sequência otimizada devolvida pelo OSRM
          lista = dados.waypoints
            .map((w, i) => ({ visita: lista[i], pos: w.waypoint_index }))
            .sort((a, b) => a.pos - b.pos)
            .map(o => o.visita);
          otimizada = true;

          const trip = dados.trips[0];
          const latlngs = trip.geometry.coordinates.map(c => [c[1], c[0]]);
          L.polyline(latlngs, { color: cor, weight: 4, opacity: 0.8 }).addTo(camadaRotas);
          distancia = (trip.distance / 1000).toFixed(1) + " km";
          const min = Math.round(trip.duration / 60);
          duracao = min >= 60 ? `${Math.floor(min / 60)}h ${min % 60}min` : `${min}min`;
        }
      } catch (error) {
        console.error("Erro ao otimizar rota do dia", dia, error);
      }
    }

    // marcadores numerados pela ordem do percurso (otimizada quando disponível);
    // o tooltip mostra a hora agendada, que pode não seguir a ordem do percurso
    const paradas = [];
    lista.forEach((v, i) => {
      const hora = v.inicio
        ? parseDataBD(v.inicio).toLocaleTimeString("pt-PT", { hour: "2-digit", minute: "2-digit" })
        : "";
      L.marker([v.lat, v.lng], { icon: criarMarcadorRota(i + 1, cor) })
        .bindTooltip(
          `<b>${i + 1}. ${v.cliente_nome || ""}</b><br>${v.local_instalacao || ""}` +
          (hora ? `<br><i class="fas fa-clock"></i> agendado ${hora}` : ""),
          { direction: "top", offset: [0, -14], opacity: 0.95 }
        )
        .addTo(camadaRotas);
      bounds.push([v.lat, v.lng]);
      paradas.push({
        ordem: i + 1,
        local: v.local_instalacao || "—",
        cliente: v.cliente_nome || "—",
        sub_cliente_bloqueado: v.sub_cliente_bloqueado,
        hora,
      });
    });

    rotasInfo.value.push({ dia: formatarDiaLabel(dia), cor, paragens: lista.length, distancia, duracao, otimizada, paradas });
  }

  if (bounds.length > 0) {
    mapaRota.fitBounds(bounds, { padding: [40, 40], maxZoom: 14 });
  }
  rotaCarregando.value = false;
}

function fecharRotaModal() {
  showRotaModal.value = false;
  rotasInfo.value = [];
  if (mapaRota) {
    mapaRota.remove();
    mapaRota = null;
    camadaRotas = null;
  }
}

// -------- Seleção em massa --------

function clearSelection() {
  selectedEventIds.value = new Set();
  document.querySelectorAll('.event-checkbox').forEach(cb => { cb.checked = false; });
}

function selectAll() {
  if (allEligibleSelected.value) {
    clearSelection();
    return;
  }
  const eligible = planeamento_data.value.filter(p => p.status !== 'fechado');
  const newSet = new Set(eligible.map(p => String(p.id)));
  selectedEventIds.value = newSet;
  nextTick(() => {
    document.querySelectorAll('.event-checkbox').forEach(cb => {
      cb.checked = newSet.has(cb.getAttribute('data-event-id'));
    });
  });
}

function getSelectedPlaneamentos() {
  return [...selectedEventIds.value]
    .map(id => planeamento_data.value.find(p => String(p.id) === id))
    .filter(Boolean);
}

async function bulkTransfer() {
  const planeamentos = getSelectedPlaneamentos();
  if (planeamentos.length === 0) return;

  const elegiveis = canDesagendarConfirmed.value
    ? planeamentos
    : planeamentos.filter(p => p.estado_decisao !== 'confirmado');
  const bloqueados = planeamentos.length - elegiveis.length;

  if (elegiveis.length === 0) {
    toast("Não é possível transferir serviços confirmados via agendamento.", { type: "warning", position: "top-center", autoClose: 3000 });
    return;
  }

  if (bloqueados > 0) {
    const { isConfirmed } = await Swal.fire({
      title: 'Atenção',
      text: `${bloqueados} serviço(s) confirmado(s) via agendamento serão ignorados. Continuar com os ${elegiveis.length} restantes?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Cancelar',
    });
    if (!isConfirmed) return;
  }

  const opcoes = tecnicos.value
    .filter(t => t.id !== select_tecnico.value)
    .map(t => `<option value="${t.id}">${t.nome}</option>`)
    .join('');

  if (!opcoes) {
    toast("Não há outros técnicos disponíveis!", { type: "warning", position: "top-center", autoClose: 2000 });
    return;
  }

  const { value: targetId, isConfirmed } = await Swal.fire({
    title: 'Transferir Serviços',
    html: `<p class="text-left mb-3">Selecione o técnico de destino para <b>${elegiveis.length}</b> serviço(s):</p>
           <select id="swal-tecnico-dest" class="w-full p-2 rounded text-black">${opcoes}</select>`,
    showCancelButton: true,
    confirmButtonText: 'Transferir',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#2563eb',
    preConfirm: () => {
      const val = document.getElementById('swal-tecnico-dest').value;
      if (!val) { Swal.showValidationMessage('Selecione um técnico'); return false; }
      return val;
    }
  });

  if (!isConfirmed) return;

  try {
    const res = await axios.post(`${baseURl}/api/v1/planeamento/bulk-transferir/`, {
      planeamento_ids: elegiveis.map(p => p.id),
      tecnico_id: parseInt(targetId),
      override_confirmed: canDesagendarConfirmed.value,
    });
    clearSelection();
    getPlaneamento();
    emit('refreshTable');
    toast(res.data?.message || 'Serviços transferidos!', { type: "success", position: "top-center", autoClose: 2000 });
  } catch (e) {
    toast(e?.response?.data?.message || 'Erro ao transferir serviços!', { type: "error", position: "top-center", autoClose: 2000 });
  }
}

async function bulkChangeDate() {
  const planeamentos = getSelectedPlaneamentos();
  if (planeamentos.length === 0) return;

  const confirmedServices = planeamentos.filter(p => p.estado_decisao === 'confirmado');
  const elegiveis = canDesagendarConfirmed.value
    ? planeamentos
    : planeamentos.filter(p => p.estado_decisao !== 'confirmado');
  const bloqueados = planeamentos.length - elegiveis.length;

  if (elegiveis.length === 0) {
    toast("Não é possível alterar a data de serviços confirmados via agendamento.", { type: "warning", position: "top-center", autoClose: 3000 });
    return;
  }

  if (bloqueados > 0) {
    // Some confirmed services blocked — user lacks override permission
    const { isConfirmed } = await Swal.fire({
      title: 'Atenção',
      text: `${bloqueados} serviço(s) confirmado(s) via agendamento serão ignorados. Continuar com os ${elegiveis.length} restantes?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Cancelar',
    });
    if (!isConfirmed) return;
  } else if (confirmedServices.length > 0 && canDesagendarConfirmed.value) {
    // User has override permission — warn that confirmed services will also be date-shifted
    const { isConfirmed } = await Swal.fire({
      title: 'Atenção',
      text: `${confirmedServices.length} serviço(s) confirmado(s) via agendamento terão a data alterada.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Cancelar',
    });
    if (!isConfirmed) return;
  }

  const uniqueDays = new Set(elegiveis.map(p => new Date(p.inicio).toDateString()));
  const sameDia = uniqueDays.size === 1;
  let dayOffset;

  if (sameDia) {
    const { value: newDate, isConfirmed } = await Swal.fire({
      title: 'Mudar Data',
      html: `<p class="text-left mb-3">Nova data para <b>${elegiveis.length}</b> serviço(s):</p>
             <input type="date" id="swal-new-date" class="w-full p-2 rounded text-black" min="${new Date().toISOString().split('T')[0]}">`,
      showCancelButton: true,
      confirmButtonText: 'Mudar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d97706',
      preConfirm: () => {
        const val = document.getElementById('swal-new-date').value;
        if (!val) { Swal.showValidationMessage('Selecione uma data'); return false; }
        return val;
      }
    });
    if (!isConfirmed) return;

    const originalDay = new Date(elegiveis[0].inicio);
    originalDay.setHours(0, 0, 0, 0);
    const newDay = new Date(newDate + 'T00:00:00');
    dayOffset = Math.round((newDay - originalDay) / 86400000);
  } else {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const earliestDate = elegiveis.reduce((min, p) => {
      const d = new Date(p.inicio);
      return d < min ? d : min;
    }, new Date(elegiveis[0].inicio));
    earliestDate.setHours(0, 0, 0, 0);
    const minOffset = Math.ceil((today - earliestDate) / 86400000);

    const { value: dias, isConfirmed } = await Swal.fire({
      title: 'Avançar Dias',
      html: `<p class="text-left mb-3">Os <b>${elegiveis.length}</b> serviços têm datas diferentes.<br>Quantos dias avançar? (negativo para recuar)</p>
             <input type="number" id="swal-days" class="w-full p-2 rounded text-black" value="1" min="${minOffset}" max="365">`,
      showCancelButton: true,
      confirmButtonText: 'Aplicar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d97706',
      preConfirm: () => {
        const val = parseInt(document.getElementById('swal-days').value);
        if (isNaN(val) || val === 0) { Swal.showValidationMessage('Insira um número válido diferente de 0'); return false; }
        const wouldGoToPast = elegiveis.some(p => {
          const d = new Date(p.inicio);
          d.setDate(d.getDate() + val);
          d.setHours(0, 0, 0, 0);
          return d < today;
        });
        if (wouldGoToPast) { Swal.showValidationMessage('O deslocamento colocaria pelo menos um serviço no passado.'); return false; }
        return val;
      }
    });
    if (!isConfirmed) return;
    dayOffset = dias;
  }

  try {
    const res = await axios.post(`${baseURl}/api/v1/planeamento/bulk-mudar-data/`, {
      planeamento_ids: elegiveis.map(p => p.id),
      days_offset: dayOffset,
      override_confirmed: canDesagendarConfirmed.value,
    });
    clearSelection();
    getPlaneamento();
    toast(res.data?.message || 'Datas atualizadas!', { type: "success", position: "top-center", autoClose: 2000 });
  } catch (e) {
    toast(e?.response?.data?.message || 'Erro ao mudar datas!', { type: "error", position: "top-center", autoClose: 2000 });
  }
}

async function bulkDesagendar() {
  const planeamentos = getSelectedPlaneamentos();
  const porEstado = planeamentos.filter(p => ['agendado', 'confirmado'].includes(p.status));

  let elegiveis, bloqueadosAgendamento;
  if (canDesagendarConfirmed.value) {
    elegiveis = porEstado;
    bloqueadosAgendamento = 0;
  } else {
    elegiveis = porEstado.filter(p => p.estado_decisao !== 'confirmado');
    bloqueadosAgendamento = porEstado.length - elegiveis.length;
  }

  const ignoradosEstado = planeamentos.length - porEstado.length;
  const totalIgnorados = ignoradosEstado + bloqueadosAgendamento;

  if (elegiveis.length === 0) {
    const motivo = bloqueadosAgendamento > 0
      ? "Os serviços selecionados estão confirmados via agendamento — cancele o agendamento primeiro."
      : "Nenhum serviço selecionado é elegível para desagendar (apenas agendados e confirmados).";
    toast(motivo, { type: "warning", position: "top-center", autoClose: 4000 });
    return;
  }

  const ignoradosTexto = bloqueadosAgendamento > 0
    ? ` (${bloqueadosAgendamento} bloqueado(s) por agendamento confirmado, ${ignoradosEstado} por estado incompatível)`
    : totalIgnorados > 0 ? ` (${totalIgnorados} ignorados por estado incompatível)` : '';

  const confirmedServices = canDesagendarConfirmed.value
    ? elegiveis.filter(p => p.estado_decisao === 'confirmado')
    : [];

  let motivo_cancelamento = '';

  if (confirmedServices.length > 0) {
    const { isConfirmed: confirmed, value: motivo } = await Swal.fire({
      title: 'Desagendar Serviços',
      html: `
        <p style="margin-bottom:8px">Serão desagendados <strong>${elegiveis.length}</strong> serviço(s).${ignoradosTexto ? `<br><small>${ignoradosTexto}</small>` : ''}</p>
        <p style="color:#fbbf24;font-size:0.85em;margin-bottom:8px"><i class="fa-solid fa-triangle-exclamation"></i> ${confirmedServices.length} serviço(s) têm agendamento confirmado — o agendamento será cancelado. Indique o motivo:</p>
        <textarea id="swal-motivo-desagendar" class="swal2-textarea" placeholder="Motivo do cancelamento do agendamento..." rows="3" style="width:90%;margin-top:4px;font-size:0.9em;"></textarea>
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Desagendar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#15803d',
      focusConfirm: false,
      preConfirm: () => {
        const val = document.getElementById('swal-motivo-desagendar')?.value?.trim();
        if (!val) {
          Swal.showValidationMessage('O motivo é obrigatório para cancelar agendamentos confirmados.');
          return false;
        }
        return val;
      },
    });
    if (!confirmed) return;
    motivo_cancelamento = motivo;
  } else {
    const { isConfirmed } = await Swal.fire({
      title: 'Desagendar Serviços',
      text: `Desagendar ${elegiveis.length} serviço(s)?${ignoradosTexto}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Desagendar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#15803d',
    });
    if (!isConfirmed) return;
  }

  try {
    const res = await axios.post(`${baseURl}/api/v1/planeamento/bulk-desagendar/`, {
      planeamento_ids: elegiveis.map(p => p.id),
      override_confirmed: canDesagendarConfirmed.value,
      motivo_cancelamento,
    });
    clearSelection();
    getPlaneamento();
    emit('confirm');
    toast(res.data?.message || `${elegiveis.length} serviço(s) desagendados!`, { type: "success", position: "top-center", autoClose: 2000 });
  } catch (e) {
    toast(e?.response?.data?.message || 'Erro ao desagendar!', { type: "error", position: "top-center", autoClose: 2000 });
  }
}

async function bulkDesalocar() {
  const planeamentos = getSelectedPlaneamentos();
  const elegiveis = planeamentos.filter(p => p.status === 'atribuido');

  if (elegiveis.length === 0) {
    toast("Nenhum serviço selecionado é elegível para desalocar (apenas atribuídos).", { type: "warning", position: "top-center", autoClose: 3000 });
    return;
  }

  const ignorados = planeamentos.length - elegiveis.length;
  const { isConfirmed } = await Swal.fire({
    title: 'Desalocar Serviços',
    text: `Desalocar ${elegiveis.length} serviço(s)?${ignorados > 0 ? ` (${ignorados} ignorados por estado incompatível)` : ''}`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Desalocar',
    cancelButtonText: 'Cancelar',
  });

  if (!isConfirmed) return;

  try {
    const res = await axios.post(`${baseURl}/api/v1/planeamento/bulk-desalocar/`, {
      planeamento_ids: elegiveis.map(p => p.id),
    });
    clearSelection();
    getPlaneamento();
    emit('confirm');
    toast(res.data?.message || `${elegiveis.length} serviço(s) desalocados!`, { type: "success", position: "top-center", autoClose: 2000 });
  } catch (e) {
    toast(e?.response?.data?.message || 'Erro ao desalocar!', { type: "error", position: "top-center", autoClose: 2000 });
  }
}

// funciona para expor funções para o componente pai, é preciso por estar a usar composition API
defineExpose({
  getPlaneamento,
  getSelectedTecnico: () => select_tecnico.value,
});

const update = async (url, data) => {
  try {
    const res = await axios.put(url, data);
    console.log("Dados atualizados com sucesso:", res.data);
    return res.data.data;
  } catch (error) {
    console.error("Erro ao atualizar dados:", error);
  }
};

</script>

<style>
.calendario-container {
  /* background-color: #0f3460; */
  border-radius: 12px;
  color: #fff;
}

/* ---- Modal de Rota do Técnico ---- */
.rota-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100000;
  padding: 16px;
}

.rota-modal-card {
  width: 1100px;
  max-width: 96vw;
  height: 80vh;
  max-height: 92vh;
  background: #16213e;
  border: 1px solid #533483;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.6);
}

.rota-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid #533483;
}

.rota-modal-header h3 {
  font-weight: 800;
  color: #fff;
  font-size: 1rem;
}

.rota-modal-header p {
  color: #9ca3af;
  font-size: 0.8rem;
}

.rota-modal-header button {
  color: #cbd5e1;
  font-size: 1.1rem;
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  flex-shrink: 0;
}

.rota-modal-header button:hover {
  background: #0f3460;
  color: #fff;
}

.rota-modal-body {
  flex: 1;
  display: flex;
  min-height: 0;
}

.rota-mapa {
  flex: 1;
  min-height: 0;
}

.rota-legenda {
  width: 260px;
  flex-shrink: 0;
  overflow-y: auto;
  padding: 12px;
  background: #0f1a33;
  border-left: 1px solid #533483;
  color: #e5e7eb;
  font-size: 0.8rem;
}

.rota-legenda-item {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 8px 0;
  border-bottom: 1px solid rgba(83, 52, 131, 0.4);
}

.rota-cor {
  width: 14px;
  height: 14px;
  border-radius: 4px;
  flex-shrink: 0;
  margin-top: 2px;
}

/* lista de locais por rota */
.rota-dia {
  padding: 8px 0;
  border-bottom: 1px solid rgba(83, 52, 131, 0.4);
}

.rota-dia-cab {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
}

.rota-paradas {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
}

.rota-paradas li {
  display: flex;
  gap: 6px;
  align-items: flex-start;
}

.rota-num {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 9999px;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
}

.rota-local {
  color: #e5e7eb;
  font-weight: 600;
  font-size: 0.76rem;
  line-height: 1.2;
}

.rota-cliente {
  color: #9ca3af;
  font-size: 0.7rem;
}

/* secção dos sem coordenadas */
.rota-sem-coord {
  margin-top: 12px;
  border-top: 2px solid #7c3aed;
  padding-top: 8px;
}

.rota-sem-coord-titulo {
  color: #fdba74;
  font-weight: 700;
  font-size: 0.8rem;
  margin-bottom: 2px;
}

.sem-coord-item {
  padding: 6px 0;
  border-bottom: 1px solid rgba(83, 52, 131, 0.4);
}

.sem-coord-morada {
  color: #9ca3af;
  font-size: 0.7rem;
  margin-top: 2px;
}

.sem-coord-meta {
  color: #6b7280;
  font-size: 0.68rem;
  margin-top: 2px;
}

.rota-pin-wrapper {
  background: transparent;
  border: none;
}

.rota-pin {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #fff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);
}

@media (max-width: 640px) {
  .rota-modal-body {
    flex-direction: column;
  }

  .rota-legenda {
    width: 100%;
    border-left: none;
    border-top: 1px solid #533483;
    max-height: 35%;
  }
}

.fc {
  background-color: #1a1a2e;
  border-radius: 8px;
  padding: 8px;
}

.fc-toolbar-title {
  color: #fff;
}

.fc-daygrid-day-number,
.fc-col-header-cell-cushion {
  color: grey;
}

.fc-event {
  background-color: #533483;
  border: none;
  color: #fff;
  font-weight: 600;
}

#tecnico {
  /* background-color: #16213e; */
  color: #fff;
  border: 1px solid #444;
}

.fc-daygrid-event-harness {
  cursor: pointer;
}

.fc-popover {
  z-index: 9999 !important;
  background-color: #1a1a2e !important;
  border: 1px solid #444 !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6) !important;
}

.fc-popover-body {
  background-color: #1a1a2e !important;
  color: #fff;
  max-height: 280px;
  overflow-y: auto;
}

.fc-theme-standard .fc-popover-header {
  background-color: #16213e !important;
  color: #fff;
  border-radius: 8px 8px 0 0;
}

.fc-popover .fc-popover-close {
  color: #fff;
}

/* Responsivo: ajustes para ecrãs pequenos (mobile) */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

@media (max-width: 640px) {
  .fc {
    padding: 4px;
    font-size: 0.78rem;
  }

  .fc .fc-toolbar.fc-header-toolbar {
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 8px;
  }

  .fc .fc-toolbar-chunk {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    justify-content: center;
    width: 100%;
  }

  .fc .fc-toolbar-title {
    font-size: 1rem !important;
    text-align: center;
    width: 100%;
  }

  .fc .fc-button {
    padding: 4px 8px !important;
    font-size: 0.72rem !important;
  }

  .fc .fc-daygrid-day-number,
  .fc .fc-col-header-cell-cushion {
    font-size: 0.7rem;
    padding: 2px;
  }

  .fc-event {
    font-size: 0.65rem;
    padding: 1px 2px;
  }
}

/* ---- Modal de Info do Serviço ---- */
.info-modal-card {
  width: 900px;
  max-width: 96vw;
  max-height: 90vh;
  background: #16213e;
  border: 1px solid #533483;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.6);
}

.info-modal-body {
  display: flex;
  gap: 20px;
  padding: 20px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

.info-modal-col {
  flex: 1;
  min-width: 0;
  /* A coluna da esquerda (observações + Guardar) tem conteúdo fixo; a da
     direita (tabela de artigos) é que cresce com muitos items — cada
     coluna faz o seu próprio scroll para o botão Guardar nunca ficar
     escondido por causa da tabela. */
  min-height: 0;
  max-height: 100%;
  overflow-y: auto;
}

.info-modal-table-wrap {
  overflow-x: auto;
}

@media (max-width: 640px) {
  .info-modal-body {
    flex-direction: column;
  }
}
</style>
